import { NewsFilter, NewsOption } from '@terminal/services/news/news.types';

type ToggleFilterOptionProps = {
  filters: NewsFilter[];
  optionKey?: string;
  filterKey: string;
  trackFilter?: () => void;
};

export type ToggleOptionProps = {
  option: NewsOption;
  optionKey?: string;
  someOptionsChecked: boolean;
};

export const toggleOption = ({
  optionKey,
  option,
  someOptionsChecked,
}: ToggleOptionProps) => {
  if (!optionKey) {
    return {
      ...option,
      isChecked: !someOptionsChecked,
    };
  }

  if (option.key === optionKey) {
    return {
      ...option,
      isChecked: !option.isChecked,
    };
  }

  return option;
};

export const toggleFilterOption = ({
  filters,
  optionKey,
  filterKey,
  trackFilter,
}: ToggleFilterOptionProps): NewsFilter[] => {
  return filters.map(filter => {
    if (filter.key === filterKey) {
      if (filterKey === 'watchlist') {
        trackFilter?.();
      }

      return {
        ...filter,
        options: filter.options.map(option =>
          toggleOption({
            optionKey,
            option,
            someOptionsChecked: filter.options.some(o => o.isChecked),
          })
        ),
      };
    }

    return filter;
  });
};
